import React from 'react'
import Translation from '../General/Translation'

const OverviewTitle = ({singleMovie, overviewSubtitle, notFound, items, movies, translation}) => {

    let title = 'Not Found'

    if(singleMovie) {
        if(items && items.length > 0 && movies.hasOwnProperty(items[0])) {
            const itemData = movies[items[0]]
            title = itemData.titleDisplay ? itemData.titleDisplay : itemData.title
        }
    } else if(notFound) {
        title = <Translation id="programOverviewMovieNotFound" trans={translation}>Programmübersicht: Film nicht vorhanden</Translation>
    } else {
        title = <Translation id="programOverview" trans={translation}>Programmübersicht</Translation>
    }


    return (
        <div className="grid-site-wrapper">
            <h1 className="overview-title title-xlarge-black">{title}</h1>
            {overviewSubtitle && <h2 className="overview-subtitle">{overviewSubtitle}</h2>}
        </div>
    )

}

export default OverviewTitle